import React, {Component} from 'react';
import config from "../config";
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import iconStar from '../assets/images/icon-star.png';
import iconArrow from '../assets/images/icon-arrow.png';
import iconMessage from '../assets/images/icon-message.png';
import singleshiftLogo from '../assets/images/singleshift-logomark.png';
import WrapWithLoader from "./WrapWithLoader";


class BusinessTrialForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.handler = window.StripeCheckout.configure({
      key: config.stripeKey,
      image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
      locale: 'auto',
      token: (token) => {
        // You can access the token ID with `token.id`.
        // Get the token ID to your server-side code for use.
        this.setState({
          loading: true
        });
        fetch(`${config.apiRoot}/businesses/${this.props.business.id}/stripe/`, {
          method: 'POST',
          body: JSON.stringify({
            token: token.id,
            email: token.email,
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(response => {
          this.setState({loading: true});
          window.analytics.track("Business Sign Up - Saved Credit Card");
          this.props.onComplete();
        }).then(error => {
        });
      }
    });
  }

  openStripeModal = () => {
    // Open Checkout with further options:
    window.analytics.track('Business Sign Up - Clicked Start Free Trial');
    this.setState({
      loading: true,
    });
    this.handler.open({
      name: 'SingleShift',
      description: 'Making food and beverage life easier.',
      currency: 'sgd',
      panelLabel: 'Save Card',
      email: this.props.email,
      image: singleshiftLogo,
      closed: () => {
        window.analytics.track("Business Sign Up - Closed Credit Card Modal");
        this.setState({
          loading: false,
        });
      },
    });
  };

  render() {
    const {classes} = this.props;

    return (
      <div className={'row justify-content-center'}>
        <div className={'col-md-12 col-lg-6'}>
          <h2 className={classes.title}>
            Start a Free Trial
          </h2>
          <Typography className={classes.subtitle} variant={'subheading'}>See how SingleShift can help your business with staffing.</Typography>
          <div className={classes.plan}>
            <div className={classes.planTitle}>Pay As You Go</div>
            <div className={classes.planContent}>
              <div className={classes.planPrice}>
                <div className={classes.amount}>$10</div>
                <div className={classes.suffix}>per shift filled</div>
              </div>
              <ul className={classes.features}>
                <li className={classes.feature}>
                  <img className={classes.featureIcon} src={iconStar}/>
                  <div className={classes.featureText}>No monthly or hidden fees</div>
                </li>
                <li className={classes.feature}>
                  <img className={classes.featureIcon} src={iconArrow}/>
                  <div className={classes.featureText}>Pay only for what you use</div>
                </li>
                <li className={classes.feature}>
                  <img className={classes.featureIcon} src={iconMessage}/>
                  <div className={classes.featureText}>Real time customer service</div>
                </li>
              </ul>
              <div className={classes.highlight}>Free for 14 days</div>
            </div>
          </div>
          <WrapWithLoader loading={this.state.loading}>
            <button
              disabled={this.state.loading}
              className="btn btn-primary btn-xlg btn-block btn-pointer"
              id="customButton" onClick={this.openStripeModal}>Start your free trial now</button>
          </WrapWithLoader>
        </div>
      </div>
    );
  }
}


export default withStyles((theme) => ({
  title: {

  },
  subtitle: {
    marginBottom: 30,
  },
  plan: {
    textAlign: 'center',
    borderRadius: 10,
    border: '1px solid #efefef',
    marginBottom: 30,
  },
  planTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    padding: '30px 0',
    borderBottom: '1px solid #efefef',
  },
  planContent: {
    padding: '30px 30px 60px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  planPrice: {
    marginBottom: 30,
  },
  amount: {
    fontSize: 48,
    fontWeight: 'bold',
    marginBottom: 0,
    lineHeight: 1.3,
  },
  suffix: {
    fontSize: 18,
    color: '#999999'
  },
  features: {
    padding: 0,
    margin: 0,
    display: 'inline-block',
  },
  feature: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 20,
  },
  featureIcon: {
    width: 25,
    height: 25,
    marginRight: 9
  },
  highlight: {
    background: '#28a745',
    padding: '5px 14px',
    borderRadius: 10,
    fontWeight: 'bold',
    color: '#ffffff',
    display: 'inline-block',
    textTransform: 'uppercase',
    fontSize: 13,
  }
}))(BusinessTrialForm);


// WEBPACK FOOTER //
// ./src/parts/BusinessTrialForm.js